module.exports = __webpack_public_path__ + "img/practice-3.8fd58034.jpg";